<template>
<div class="main_view">
  <iframe class="home_view" :src="html_src">
  </iframe>
</div>
</template>

<script>
export default {
  name: "HomeS",
  data(){
    return {
      html_src: '',
    }
  },
  mounted() {
    this.html_src = '/static/home_s.html';
  },
  metaInfo: {
    title: "袤周官网",
    meta: [
      { name: "keywords", content: "袤周，大数据驱动下的智慧种草平台。" },
      { name: "description", content: "袤周，大数据驱动下的智慧种草平台。袤周-覆盖素人、KOC、KOL的种草对接平台。目前活跃的素人和KOC有100万+，KOL有50万+，总体覆盖小红书、抖音、快手、知乎、得物、大众店铺、淘宝、京东等多个平台。我们利用大数据，为商家筛选并适配最优的KOL，全流程通过平台直到，摒弃中间商对接和人力沟通的多个高成本环节。同时，袤周还可以实现KOC和素人的快速闪投，无需选账号，平台通过KOC和素人的主动抢单模式，加上线上审稿，可在1-2周内执行完毕任务。智能又高效，这是5G时代智慧MCN革新的关键词。" },
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .main_view
    width 100%
    height auto
    overflow hidden
    .home_view
      width 100%
      border none
      height 4720px
</style>



// WEBPACK FOOTER //
// src/components/HomeS.vue